/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { PublicService } from "src/services/PublicService";
import { Button, Col, Form, FormGroup, Row, Label, Input } from "reactstrap";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare } from "@fortawesome/free-regular-svg-icons/faCheckSquare";
import { faSquare } from "@fortawesome/free-regular-svg-icons/faSquare";

const interestsHash: any = {
  "5a11f2c1cd": "Free Courses",
  "6343b1b7de": "Licensed Health Provider",
  // eslint-disable-next-line prettier/prettier
  b58943fcf8: "Guide or Sitter",
  // eslint-disable-next-line prettier/prettier
  eb6a981b82: "Researcher",
};
const freeCourses = "5a11f2c1cd";
const mentalHealthProfessional = "6343b1b7de";
const guideSitter = "b58943fcf8";
const researcher = "eb6a981b82";
interface SubscribeFreeCoursesProps {
  successCb?: (interests: string[]) => void;
}

// eslint-disable-next-line react/display-name
export const SubscribeFreeCourses: React.FunctionComponent<SubscribeFreeCoursesProps> = React.memo(
  (props: SubscribeFreeCoursesProps) => {
    // form actions
    const [submitted, setSubmitted] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const [errored, setErrored] = React.useState(false);
    const [formErrors, setFormErrors] = React.useState(null);

    // form fields
    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [interests, setInterests] = React.useState([]);

    const { executeRecaptcha } = useGoogleReCaptcha();

    const toggleInterest = (interest: string) => {
      if (interests.includes(interest)) {
        setInterests(
          interests.filter((i) => {
            return i !== interest;
          }),
        );
      } else {
        setInterests(interests.concat([interest]));
      }
    };

    const checkFormErrors = (name: string, value: string) => {
      let error;
      switch (name) {
        case "firstName":
          error = value && value.length ? "" : "First Name is Required";
          break;
        case "lastName":
          error = value && value.length ? "" : "Last Name is Required";
          break;
        case "email":
          error = value && /^[\w%+.-]+@[\d.a-z-]+\.[a-z]{2,10}$/i.test(value) ? "" : "Email is not valid!";
          break;
        case "interests":
          error = value ? "" : "Please let us know more about you, it's for science! :)";
          break;
        default:
          break;
      }
      return error;
    };
    const validateForm = () => {
      let valid = true;
      const errors = {} as any;
      errors.email = checkFormErrors("email", email);
      errors.firstName = checkFormErrors("firstName", firstName);
      errors.lastName = checkFormErrors("lastName", lastName);
      errors.interests = checkFormErrors("interests", interests ? interests.join("") : "");
      Object.keys(errors).forEach(
        // if we have an error string set valid to false
        (p: any) => {
          if (errors[p] && errors[p].length > 0) {
            valid = false;
          }
        },
      );
      return { valid, errors };
    };

    const handleSubmit = async (event: any) => {
      event.preventDefault();
      try {
        setSubmitting(true);
        setErrored(false);
        const myForm = validateForm();
        if (!myForm.valid) {
          setSubmitting(false);
          setFormErrors(myForm.errors);
          return;
        }
        const theInterests = interests.map((i) => {
          return i;
        });
        // should add free course interest for everyone
        if (!interests.includes(freeCourses)) {
          theInterests.push(freeCourses);
        }
        const token = await executeRecaptcha("subscribeInterests");
        const values = {
          firstName,
          lastName,
          email,
          interests: theInterests,
        };
        await PublicService.subscribeEmailMarketing(values, token);
        if (props.successCb) {
          const mappedInterests: string[] = interests.map((i) => {
            return interestsHash[i];
          });
          props.successCb(mappedInterests);
        }
        setSubmitted(true);
      } catch (error) {
        setErrored(true);
        console.error(error);
        setSubmitting(false);
      }
    };
    // tslint:disable:max-line-length
    return (
      <div className="subscribe-interests">
        {!submitted && (
          <div>
            <Row>
              <Col xs="12">
                <Form role="form" className="subscribe-interests" onSubmit={handleSubmit}>
                  <Row>
                    <Col xs="6">
                      <FormGroup className="mb-3">
                        <Label for="name" id="lbl-firstName">
                          First Name:
                        </Label>
                        <br />
                        <Input
                          type="text"
                          autoComplete="given-name"
                          value={firstName}
                          name="firstName"
                          placeholder="First Name"
                          onChange={(e) => setFirstName(e.target.value)}
                        />
                        {formErrors && formErrors.firstName && (
                          <div className="has-error">
                            <div className="form-feedback">{formErrors.firstName}</div>
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col xs="6">
                      <FormGroup className="mb-3">
                        <Label for="name" id="lbl-lastName">
                          Last Name:
                        </Label>
                        <br />
                        <Input
                          type="text"
                          autoComplete="family-name"
                          value={lastName}
                          name="lastName"
                          placeholder="Last Name"
                          onChange={(e) => setLastName(e.target.value)}
                        />
                        {formErrors && formErrors.lastName && (
                          <div className="has-error">
                            <div className="form-feedback">{formErrors.lastName}</div>
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12">
                      <FormGroup className="mb-3">
                        <Label for="name" id="lbl-email">
                          Email:
                        </Label>
                        <Input
                          type="text"
                          autoComplete="email"
                          name="email"
                          value={email}
                          placeholder="Email"
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        {formErrors && formErrors.email && (
                          <div className="has-error">
                            <div className="form-feedback">{formErrors.email}</div>
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12">
                      <FormGroup className="mb-3">
                        <Label for="name" id="lbl-email">
                          Tell us a little more yourself:
                        </Label>
                        <div>
                          <FontAwesomeIcon
                            icon={interests.includes(mentalHealthProfessional) ? faCheckSquare : faSquare}
                            className="cursor-pointer"
                            onClick={(): void => {
                              toggleInterest(mentalHealthProfessional);
                            }}
                          />
                          &nbsp;I'm a Licensed Health Provider
                        </div>
                        <div>
                          <FontAwesomeIcon
                            icon={interests.includes(guideSitter) ? faCheckSquare : faSquare}
                            className="cursor-pointer"
                            onClick={(): void => {
                              toggleInterest(guideSitter);
                            }}
                          />
                          &nbsp;I'm a Sitter or Guide
                        </div>
                        <div>
                          <FontAwesomeIcon
                            icon={interests.includes(researcher) ? faCheckSquare : faSquare}
                            className="cursor-pointer"
                            onClick={(): void => {
                              toggleInterest(researcher);
                            }}
                          />
                          &nbsp;I'm a Researcher
                        </div>
                        <div>
                          <FontAwesomeIcon
                            icon={interests.includes(freeCourses) ? faCheckSquare : faSquare}
                            className="cursor-pointer"
                            onClick={(): void => {
                              toggleInterest(freeCourses);
                            }}
                          />
                          &nbsp;👽 🌈 🍄 (other)
                        </div>
                        {formErrors && formErrors.interests && (
                          <div className="has-error">
                            <div className="form-feedback">{formErrors.interests}</div>
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col xs="12" className="text-center">
                      <Button id="btn-submit" color="secondary" type="submit" disabled={submitting}>
                        Sign up for Free Courses
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                {errored && (
                  <FormGroup>
                    <div className="form-feedback">There was an error submitting your request, please try again!</div>
                  </FormGroup>
                )}
              </Col>
            </Row>
          </div>
        )}
        {!props.successCb && submitted && <div className="text-center">Got it! Check your inbox :)</div>}
      </div>
    );
  },
);
